"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.disabledModifiers = exports.statusModifiers = exports.sizeModifiers = exports.typeModifiers = void 0;

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _styledComponents = require("styled-components");

var _designTokens = require("@decisiv/design-tokens");

var _elements = require("./elements");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var sizes = {
  checkbox: {
    normal: {
      styledInput: 22
    },
    small: {
      styledInput: 18
    }
  },
  radio: {
    normal: {
      styledInput: 24,
      radioCheckMark: 10
    },
    small: {
      styledInput: 20,
      radioCheckMark: 8
    }
  }
};

var typeModifiers = function typeModifiers(_ref) {
  var isRadio = _ref.isRadio;

  if (!isRadio) {
    return undefined;
  }

  return (0, _styledComponents.css)(["", "{border-radius:50%;}"], _elements.StyledInput);
};

exports.typeModifiers = typeModifiers;

var sizeModifiers = function sizeModifiers(_ref2) {
  var size = _ref2.size,
      isRadio = _ref2.isRadio;
  var type = isRadio ? 'radio' : 'checkbox';

  if (size === 'small') {
    return (0, _styledComponents.css)(["", "{width:", ";height:", ";}", "{width:", ";height:", ";}span{font-size:", ";}"], _elements.StyledInput, (0, _rem.default)(sizes[type].small.styledInput), (0, _rem.default)(sizes[type].small.styledInput), _elements.RadioCheckMark, (0, _rem.default)(sizes.radio.small.radioCheckMark), (0, _rem.default)(sizes.radio.small.radioCheckMark), (0, _rem.default)(_designTokens.typography.size.alias.paragraph2));
  }

  return (0, _styledComponents.css)(["", "{width:", ";height:", ";}", "{width:", ";height:", ";}span{font-size:", ";}"], _elements.StyledInput, (0, _rem.default)(sizes[type].normal.styledInput), (0, _rem.default)(sizes[type].normal.styledInput), _elements.RadioCheckMark, (0, _rem.default)(sizes.radio.normal.radioCheckMark), (0, _rem.default)(sizes.radio.normal.radioCheckMark), (0, _rem.default)(_designTokens.typography.size.alias.paragraph));
};

exports.sizeModifiers = sizeModifiers;

var statusModifiers = function statusModifiers(_ref3) {
  var status = _ref3.status,
      warningMessage = _ref3.warningMessage;
  var hasWarning = status === 'warning' || !!warningMessage;

  if (!hasWarning) {
    return undefined;
  }

  return (0, _styledComponents.css)(["input + label,input + label:hover,input:focus + label{", "{border-color:", ";}}"], _elements.StyledInput, (0, _toColorString.default)(_designTokens.color.status.warning.medium));
};

exports.statusModifiers = statusModifiers;

var disabledModifiers = function disabledModifiers(_ref4) {
  var isDisabled = _ref4.isDisabled;
  return (0, _styledComponents.css)(["input{&:disabled + label,&[readonly] + label{cursor:not-allowed;", "{background:", ";border-color:", ";> *{color:", ";}}}", "}"], _elements.StyledInput, (0, _toColorString.default)(_designTokens.color.opacity.fullMoon50), (0, _toColorString.default)(_designTokens.color.base.quarterMoon), (0, _toColorString.default)(_designTokens.color.opacity.charcoal40), isDisabled === true && (0, _styledComponents.css)(["+ label span{color:", ";}"], (0, _toColorString.default)(_designTokens.color.opacity.charcoal40)));
};

exports.disabledModifiers = disabledModifiers;